import React, { Component } from 'react';
import { Button, Grid, Cell, Card } from 'react-md';
import numeral from 'numeral';
import { PieChart, Pie } from 'recharts';
import { trackEvent } from '../../util/analytics';
import './PercentCard.scss';

class PercentCard extends Component {
  constructor(props) {
    super(props);

    const attacksBlocked = props.bundleSummary.attacks_blocked;
    const reportsReceived = props.bundleSummary.reports_received;
    // Clip min-value to 0 - error case protection
    const attacksNotBlocked = Math.max(reportsReceived - attacksBlocked, 0);

    const data = [
      { name: 'Blocked', value: attacksBlocked },
      { name: 'Unblocked', value: attacksNotBlocked },
    ];

    const colors = [
      '#385A9A', // blue
      '#BD2031', // red
    ];

    this.state = {
      data,
      colors,
      ratioBlocked: attacksBlocked / reportsReceived,
    };
  }

  handleClickLearnMore = () => {
    window.open('https://www.datatheorem.com/products/protection/', '_blank');
    trackEvent({
      category: 'External',
      action: 'App Protection',
    });
  };

  formatPercent(ratio) {
    return numeral(ratio).format('0.0%');
  }

  render() {
    const isActiveMode = this.state.ratioBlocked >= 0.3;
    const judgmentMessage = isActiveMode
      ? 'Congratulations! Eavesdropping attacks on private communication are blocked; however, 30+ additional items should be considered to fully protect your app.'
      : 'You have configured TrustKit to allow attackers to eavesdrop on private communications within your app.';
    const baseFillColor = this.state.colors[isActiveMode ? 0 : 1];

    return (
      <div className="percent-container md-grid mobile-fix">
        <Card className="md-block-centered">
          <Grid className="percent-grid">
            {isActiveMode && (
              <Grid className="percent-grid">
                <Cell size={2} className="percent-grid-cell">
                  <div className="percent-grid-inside">
                    <PieChart width={70} height={70}>
                      <Pie
                        data={this.state.data}
                        dataKey="value"
                        nameKey="name"
                        cx="50%"
                        cy="50%"
                        outerRadius={30}
                        fill={baseFillColor}
                        isAnimationActive={false}
                      >
                        {this.state.data.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={this.state.colors[index]}
                          />
                        ))}
                      </Pie>
                    </PieChart>
                  </div>
                </Cell>
                <Cell size={3} className="percent-grid-cell">
                  <div className="percent-focus percent-grid-inside">
                    <h2 className="percent-num">
                      {this.formatPercent(this.state.ratioBlocked)}
                    </h2>
                  </div>
                </Cell>
                <Cell size={6} className="percent-grid-cell percent-prose-two">
                  <h2 className="percent-subheading percent-grid-inside">
                    of eavesdropping attacks blocked by TrustKit
                  </h2>
                </Cell>
                <Cell size={12}>
                  <hr className="horizontal-rule" />
                </Cell>
              </Grid>
            )}
            <Cell size={12} className="percent-prose-cell">
              <div className="percent-prose-container">
                <h2 className="percent-prose">{judgmentMessage}</h2>
              </div>
            </Cell>
            <Cell size={12}>
              <div className="button-container">
                <Button
                  raised
                  primary
                  className="learn-more-button"
                  style={{ background: 'grey' }}
                  onClick={this.handleClickLearnMore}
                >
                  Learn more
                </Button>
              </div>
            </Cell>
          </Grid>
        </Card>
      </div>
    );
  }
}

export default PercentCard;



// WEBPACK FOOTER //
// ./src/components/PercentCard/PercentCard.jsx